import { render } from "./ServiceDefinitions.vue?vue&type=template&id=69589894&scoped=true&ts=true"
import script from "./ServiceDefinitions.vue?vue&type=script&lang=ts"
export * from "./ServiceDefinitions.vue?vue&type=script&lang=ts"

import "./ServiceDefinitions.vue?vue&type=style&index=0&id=69589894&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69589894"]])

export default __exports__